import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import CryptoJS from "crypto-js";
import pako from "pako";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [role, setRole] = useState(null);
  const [name, setName] = useState("");
  const [designation, setDesignation] = useState("");
  const [userId, setUserId] = useState(null);
  const JWT_PAYLOAD_SECRET = process.env.REACT_APP_JWT_PAYLOAD_SECRET;
  const resetPermissions = () => {
    setPermissions([]);
  };

  useEffect(() => {
    const authData = localStorage.getItem("authData");
    if (authData) {
      try {
        const parsedData = JSON.parse(authData);

        setAuth(parsedData);
        const { token, userToken } = parsedData;
        // if (token) {
        //   fetchPermissions(token);
        // }
        // if (userToken) {
        //   const decryptedUserData = decryptPayload(
        //     userToken,
        //     JWT_PAYLOAD_SECRET
        //   );
        //   if (decryptedUserData) {
        //     setUserId(decryptedUserData.user.id);
        //     setName(decryptedUserData.user.name || "");
        //     setDesignation(decryptedUserData.user.designation || "");
        //   }
        // }
        // fetchPermissions(parsedData.token);

        if (token) {
          const decryptedData = decryptPayload(token, JWT_PAYLOAD_SECRET);
          console.log("dec", decryptedData);
          if (decryptedData) {
            fetchPermissions(token);
          }
        }
        if (userToken) {
          const decryptedUserData = decryptPayload(
            userToken,
            JWT_PAYLOAD_SECRET
          );
          if (decryptedUserData && decryptedUserData.user) {
            setUserId(decryptedUserData.user.id);
            setName(decryptedUserData.user.name || "");
            setDesignation(decryptedUserData.user.designation || "");
          }
        }
      } catch (error) {
        console.error("Error setting up AuthProvider:", error);
      }
    }
  }, []);

  const fetchPermissions = (token) => {
    try {
      const decryptedData = decryptPayload(token, JWT_PAYLOAD_SECRET);
      // console.log("Decrypted Token :", JWT_PAYLOAD_SECRET);
      // console.log("Decrypted Token Data:", decryptedData);

      if (decryptedData && decryptedData.user) {
        const user = decryptedData.user;
        setUserId(user.id);

        // const userPermissions = user.permissions?.permissions.map(
        //   (permission) => permission.permissionName
        // );

        const userPermissions = user.permissions;
        // const userName = user.name;
        const designation = user.designation;

        setPermissions(userPermissions || []);
        setRole(user.userRole || null);
        setName(user.name || "");
        setDesignation(designation || "");
        setUserId(user.id || "");
      } else {
        setPermissions([]);
        setName("");
        setDesignation("");
        setUserId(null);
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  const decryptPayload = (token, secretKey) => {
    try {
      const decoded = jwtDecode(token);

      if (!decoded || !decoded.iv || !decoded.encryptedPayload) {
        console.error("Invalid token format. Missing IV or encrypted payload.");
        return null;
      }

      const encryptedWordArray = CryptoJS.enc.Hex.parse(
        decoded.encryptedPayload
      );
      const ivWordArray = CryptoJS.enc.Hex.parse(decoded.iv);

      const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: encryptedWordArray,
      });

      const decrypted = CryptoJS.AES.decrypt(
        cipherParams,
        CryptoJS.enc.Hex.parse(secretKey),
        {
          iv: ivWordArray,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );

      let decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

      if (!decryptedText) {
        console.error("Decryption returned an empty string.");
        return null;
      }

      // If the payload is compressed with zlib, decompress it
      try {
        const decompressedData = pako.inflate(
          Uint8Array.from(atob(decryptedText), (c) => c.charCodeAt(0)),
          { to: "string" }
        );
        decryptedText = decompressedData;
      } catch (zlibError) {
        console.warn(
          "Decompression failed, assuming plaintext JSON:",
          zlibError
        );
      }

      try {
        return JSON.parse(decryptedText);
      } catch (jsonError) {
        console.error("Decrypted text is not valid JSON:", decryptedText);
        return null;
      }
    } catch (error) {
      console.error("Decryption error:", error);
      return null;
    }
  };

  const clearAuthData = () => {
    localStorage.removeItem("authData");
    sessionStorage.removeItem("authData");
    setAuth(null);
    setPermissions([]);
  };

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        permissions,
        setPermissions,
        role,
        resetPermissions,
        clearAuth: clearAuthData,
        fetchPermissions,
        name,
        designation,
        userId,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
